import { useCallback, useState } from "react";
import { createUser, resetPassword, sendEmailConfirmation, updateUser, resendInvitation } from "../services/userService";

export const useUpdateUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const execute = useCallback(async (id, payload) => {
    setLoading(true);
    setError("");
    try {
      const updated = await updateUser(id, payload);
      return updated;
    } catch (e) {
      setError(e?.message || "Failed to update user.");
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { updateUser: execute, loading, error, setError };
};

export const useCreateUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const execute = useCallback(async (payload) => {
    setLoading(true);
    setError("");
    try {
      const created = await createUser(payload);
      return created;
    } catch (e) {
      setError(e?.message || "Failed to create user.");
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { createUser: execute, loading, error, setError };
};

export const useSendEmailConfirmation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const execute = useCallback(async (userId) => {
    setLoading(true);
    setError("");
    try {
      await sendEmailConfirmation(userId);
    } catch (e) {
      setError(e?.message || "Failed to send email confirmation.");
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { sendEmailConfirmation: execute, loading, error, setError };
};

export const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const execute = useCallback(async (userId) => {
    setLoading(true);
    setError("");
    try {
      await resetPassword(userId);
    } catch (e) {
      setError(e?.message || "Failed to reset password.");
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { resetPassword: execute, loading, error, setError };
};

export const useResendInvitation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const execute = useCallback(async (userId) => {
    setLoading(true);
    setError("");
    try {
      await resendInvitation({ userId });
    } catch (e) {
      setError(e?.message || "Failed to resend invitation.");
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { resendInvitation: execute, loading, error, setError };
};
